export function generateSkinDefaults(allSkins) {
    return Object.entries(allSkins).reduce((acc, [skinName, skinParams]) => {
        acc[skinName] = Object.entries(skinParams).reduce((skinDefaults, [paramName, def]) => {
            const { type, defaultValue } = def;
            skinDefaults.types[paramName] = type;
            if (defaultValue) {
                skinDefaults.defaults[paramName] = defaultValue;
            }
            return skinDefaults;
        }, { types: {}, defaults: {} });
        return acc;
    }, {});
}
//# sourceMappingURL=skinParams.js.map